import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';
import { PageBackButton } from './PageBackButton';
import { PageTitleItems } from './PageTitleItems';

interface PageTitleProps {
  icon?: React.ReactNode;
  title?: React.ReactNode | React.ReactNode[];
  backBtn?: boolean | string;
}

/** Page header title block: optional back button, icon, and breadcrumb-style title items. */
export function PageTitle({ icon, title, backBtn }: PropsWithChildren<PageTitleProps>) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        fontWeight: '500',
        color: 'text.primary',
        gap: 1.5,
      }}
    >
      {backBtn && <PageBackButton to={typeof backBtn === 'string' ? backBtn : undefined} />}
      {icon}
      <PageTitleItems items={title} />
    </Box>
  );
}
